import React from 'react'
import { Customize, supportRequestService } from '@rebeldotcom/ui'
import Layout from '../components/layout'

const { SUPPORT_REQUEST_TYPES } = supportRequestService

const recommendations = [
  {
    itemCode: 'PPMANAGEDWORDPRESSBASE1',
  },
  {
    itemCode: 'PRIVACY',
  },
  {
    itemCode: 'DMLOCK',
  },
  {
    itemCode: 'DMEXPINSURANCE',
  },
  {
    itemCode: 'GW_STARTER_USER',
  },
  {
    itemCode: 'GW_BUSINESS_USER',
  },
  {
    itemCode: 'MARKETGOOPRO',
  },
]

const protection = {
  title: `Keeping you secure online`,
  info: '3 products. 3 ways to stay safe online. We’re not automatically adding these to your cart, but they are great add-ons to consider.',
  contentA: `
	<div>
	<p>
		<div><b>Domain Privacy Protection</b></div>
		<div>Secure your domains and hide your personal information from the WHOIS directory.</div>
	</p>
	</div>
	`,
  contentB: `
	<div>
	<p>
		<div><b>Ownership and Expiry Protection</b></div>
		<div>Prevent information changes and secure this domain to your account.</div>
		<div>We'll hold your domain for 1 year if annual payment fails, so you don't lose it.</div>
	</p>
	</div>
	`,
  fullProtection: 'Yes, hide my information',
  privacyProtection: 'Yes, hide my information',
  none: 'No thanks, expose my information',
  privacyProtectionNone: 'No thanks, expose my information',
  ownershipProtection: 'Yes, protect my domain',
  ownershipProtectionNone: 'No thanks',
  learnMore: 'Learn More',
  url: '/security/domain-privacy',
  privacyUrl: '/security/domain-privacy',
  protectionUrl: '/security/domain-protection',
}

const email = {
  title: `Level up with a custom email address.`,
  info: 'Show you mean business with professional email address that matches your new domain name',
  businessStarter: 'Business Starter - Includes Google Workspace',
  businessStandard: 'Business Standard - Includes Google Workspace',
  businessStarterDescription:
    '<ul><li>30 GB cloud storage per user</li><li>100 participant video meetings</li><li>Security and management controls</li></ul>',
  businessStandardDescription:
    '<ul><li>2 TB cloud storage per user</li><li>150 participant video meetings + recording</li><li>Security and management controls</li></ul>',
  none: 'No Thanks',
}

const managedWordpress = {
  cta: 'Add Managed WordPress',
  rebelHead: '- 50% off first term!',
  nicHead: '- 60% off first term!',
  description:
    '<p>Rebel Managed WordPress is a Rebel hosting package specifically designed to support WordPress websites. It’s a great choice for anyone starting their first business website or for those who simply prefer to let someone else deal with the ins and outs of site building including the small hassles like updates and technical adjustments.</p><p>Note: This product can be billed monthly or yearly.</p>',
}

const websiteDesign = {
  title: 'Need help designing your website?',
  prePrice: 'Starting at',
  price: '$500',
  description:
    'Let us do the heavy lifting. Our design team will be in touch using the email on your account',
  placeholder: 'Yes, contact me',
  requestType: SUPPORT_REQUEST_TYPES.REBEL_WEB_DESIGN,
  cta: 'Yes, contact me',
}

const seoTools = {
  title: 'Add SEO Tools',
  description:
    'Navigate SEO with a personalised SEO improvement plan & step by step instructions, reports, and competitor and keyword tracking.',
}

const strings = {
  continue: 'Continue to checkout',
  skip: 'Skip to Checkout',
  back: 'Back',
  heading: 'What would you like to do with your domain?',
  subHeading:
    'All of our hosting packages below come with a free Let’s Encrypt SSL certificate and a 99.9% uptime guarantee.',
  websiteDesign,
  managedWordpress,
  protection,
  email,
  seoTools,
}

const CustomizePage = () => {
  // Quick workaround for testing!!!
  const Wrapper = process.env.NODE_ENV === 'test' ? 'div' : Layout

  return (
    <Wrapper hasNavigation={false} location="/customize">
      <Customize recommendations={recommendations} strings={strings} />
    </Wrapper>
  )
}

export default CustomizePage
